import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ClientesModalComponent } from '../modals/clientes-modal/clientes-modal.component';
import { Cliente } from '../models/cliente';
import { GlobalService } from '../services/global.service';
import { NotificacaoService } from '../services/notificacao.service';
import { CarregandoService } from '../services/carregando.service';
import { Ibge } from '../models/ibge';
import { IbgeService } from '../services/ibge.service';
import { ProdutoService } from '../services/produto.service';
import { Produto } from '../models/produto';
import { Marca } from '../models/marca';
import { UtilitarioService } from '../services/utilitario.service';
import { PremissasService } from '../services/premissas.service';
import { PedidoService } from '../services/pedido.service';
import { ClienteService } from '../services/cliente.service';
import { MarcaService } from '../services/marca.service';
import { Irradiacao } from '../models/irradiacao';
import { Fileira } from '../models/fileira';
import swal from 'sweetalert2';
import { Pedido } from '../models/pedido';
import { IrradiacaoService } from '../services/irradiacao.service';
import { NgForm } from '@angular/forms';
import { DetalheEstruturaModalComponent } from '../modals/detalhe-estrutura-modal/detalhe-estrutura-modal.component';
import { LogAcesso } from '../models/log-acesso';
import { TipoArquivo, TipoDeLogAcesso } from '../models/enum';
import { LogAcessoService } from '../services/log-acesso.service';
import { Router } from '@angular/router';
import { FuncionarioService } from '../services/funcionario.service';
import { FornecedorEstruturaService } from '../services/fornecedor-estrutura.service';
import { Fornecedor } from '../models/fornecedor';
import { FornecedorService } from '../services/fornecedor.service';
import { UsuarioLogado } from '../models/usuario-logado';
import { EstruturasPersonalizadas } from '../models/estruturas-personalizadas';
import { PremissasSistema } from '../models/premissas-sistema';
import { AgrupamentoStringboxService } from '../services/agrupamento-stringbox.service';
import { ArquivoService } from '../services/arquivo.service';
import { AgrupamentoStringbox } from '../models/agrupamento-stringbox';
import { AgrupamentoStringboxSelecao } from '../models/agrupamento-stringbox-selecao';
import { concat, Observable, of, Subject } from 'rxjs';
import { catchError, distinctUntilChanged, map, switchMap, tap } from 'rxjs/operators';

declare const $: any;

@Component({
  selector: 'app-montar-kit-novo',
  templateUrl: './montar-kit-novo.component.html',
  styleUrls: ['./montar-kit-novo.component.scss']
})
export class MontarKitNovoComponent implements OnInit {
  fileira: Fileira;
  fileiras = [];

  idPainel;
  codErpPainel;

  fileirasDeVolta = [];

  agrupamentosEstrutura: any[] = [];

  marcasStringbox: Marca[] = [];
  marcaStringboxSelecionada;

  vendedor = undefined;
  limDesc = undefined;

  msgQtdPaineis = false;

  jaSelecionouCidade = false;

  filtroCidade;

  estados = [
    'AC',
    'AL',
    'AP',
    'AM',
    'BA',
    'CE',
    'DF',
    'ES',
    'GO',
    'MA',
    'MT',
    'MS',
    'MG',
    'PA',
    'PB',
    'PR',
    'PE',
    'PI',
    'RJ',
    'RN',
    'RS',
    'RO',
    'RR',
    'SC',
    'SP',
    'SE',
    'TO'
  ];

  referenciaPainel = undefined;

  calculadora = true;

  cliente = undefined;
  clienteIntegrador = undefined;
  descontoFrete = undefined;
  nome = undefined;
  descontoMaximo = undefined;

  cidade: Ibge;
  cidadeSelecionado = undefined;

  cidades$: Observable<Ibge[]>;
  cidadesLoading = false;
  cidadesInput$ = new Subject<string>();

  paineis: Produto[] = [];
  temPainelNomeGrande = false;

  tensoesMo = [{ id: 1, nome: '220' }];
  tensoesBi = [
    { id: 1, nome: '220' },
    { id: 2, nome: '380' }
  ];
  tensoesTri = [
    { id: 1, nome: '220' },
    { id: 2, nome: '380' },
    { id: 3, nome: '+380' }
  ];
  fases = [
    { id: 0, nome: 'Monofásico' },
    // { id: 1, nome: 'Bifásico' },
    { id: 2, nome: 'Trifásico' }
  ];

  tiposCalculo = [
    { id: '0', nome: 'Consumo' },
    { id: '1', nome: 'Potência' }
  ];

  incluirStringBox = true;
  faseSelecionada: any;
  tensaoSelecionada: any;
  marcaSelecionada: number = -1;
  marcas: Marca[];
  estadoSelecionado = undefined;
  voltouPagina = false;
  calcularPor = '1';
  fornecedorPadrao: any;
  fornecedores = [];
  fornecedorSelecionado: any;
  multiFornecedores = false;
  mostrarTelhado = false;
  calculoGeracao = { numeroDiasMes: 30.4, eficienciaDoPainel: 0.86 };
  integrador = false;
  buscouCidadeDoIntegrador = false;
  alterouEstado = false;
  storage: any = {};
  painelSelecionado: any;
  quantidadeDePaineis: number;
  potTotal: number;
  potTotalDesejada: number;
  potenciaDesejada;
  usarTransformador = false;
  usarTransformadorPremissas = false;
  telhadoSelecionado: any;
  potenciaPainel;
  larguraPainel;
  comprimentoPainel;
  alturaPainel;
  idFornecedor;
  perdas;
  fatorGeracao;
  irradiacao: Irradiacao;
  novaFileira: Fileira = new Fileira();
  erroTensaoSelecionada = false;
  textoKitFechado = 'Kit Fechado';
  telhados = [];

  comEstrutura = false;
  comEstruturaDeVolta = false;

  podePresseguir = false;

  orcamento: Pedido = new Pedido();

  calculou = false;

  percGeracao = 100;
  producaoPorPainel: number;
  meses = [];

  // layout

  fornecedoresDisponiveis = [];
  usarTelCeramico = true;
  estruturasPersonalizadas: EstruturasPersonalizadas = new EstruturasPersonalizadas();
  orientacaoPaisagem = true;
  mostrarValores = false;
  possuiLargura = false;
  possuiComprimento = false;
  mostrarBifasico = false;
  telhado: any;
  configurouLayout = false;
  naoLimparCidadeSelecionada = false;

  telhadoNaCalculadora = false;
  pCentroDistribuicao = false;

  qtdMaxPainelPorFileira = 0;
  marcasInversores = [];

  possuiIrradiacao = false;

  intPodeAlterarCD = false;
  mostrarMsgTrocaCD = { valor: false, msg: '' };

  cds: Fornecedor[] = [];

  tiposInv = [];

  tipoInv = undefined;

  @ViewChild('fileiraForm', { static: false }) fileiraForm: NgForm;

  usuarioLogado: UsuarioLogado;
  bloquearSistema: boolean = false;
  administrador: boolean = false;

  pObrigaSelecionarTipoInversor: boolean = false;

  premissasSistema: PremissasSistema = new PremissasSistema();

  vendPodeAlterarCD = false;

  constructor(
    private dialog: MatDialog,
    private globalService: GlobalService,
    private notificacaoService: NotificacaoService,
    private carregandoService: CarregandoService,
    private ibgeService: IbgeService,
    private produtoService: ProdutoService,
    private utilitarioService: UtilitarioService,
    private premissasService: PremissasService,
    private pedidoService: PedidoService,
    private clienteService: ClienteService,
    private marcaService: MarcaService,
    private irradiacaoService: IrradiacaoService,
    private logAcessoService: LogAcessoService,
    private router: Router,
    private funcionarioService: FuncionarioService,
    private fornecedorEstruturaService: FornecedorEstruturaService,
    private fornecedorService: FornecedorService,
    private agrupamentoStringboxService: AgrupamentoStringboxService,
    private arquivoService: ArquivoService
  ) {
    if (this.router.getCurrentNavigation().extras.state) {
      if (this.router.getCurrentNavigation().extras.state.fileirasDeVolta) {
        this.comEstrutura = true;
        this.comEstruturaDeVolta = true;
        this.fileirasDeVolta = this.router.getCurrentNavigation().extras.state.fileirasDeVolta;
      }
    }
  }

  async ngOnInit() {
    this.loadCidade();

    this.usuarioLogado = await this.globalService.consultaUsuario();
    this.administrador = await this.globalService.administrador();
    this.integrador = await this.globalService.integrador();

    if (!this.integrador) {
      this.buscarVendPodeAlterarCD();
    }

    this.orcamento.dispEstoque = true;

    await this.buscarPremissasSistema();

    // if (!this.premissasSistema.habilitarMenuSolar) {
    //   this.router.navigate(['/']);
    // }

    if (!this.premissasSistema.habilitaMenuMontarKit) {
      this.router.navigate(['/']);
    }

    await this.buscarPremissaCentroDeDistribuicao();
    await this.buscarObrigaSelecionarTipoInversor();

    this.buscarQtdPainelPorFileira();
    this.buscarUsarTransformador();
    this.buscarUsarTelhadoCeramico();
    this.buscarMultiFornecedores();
    this.buscarMostrarBifasico();
    this.buscarTextoKitFechado();
    this.verificarPremissas();
    this.buscarEstruturasPersonalizadas();
    this.buscarVerPrecosProdutos();
    this.buscarDesativarPaisagem();
    this.buscarPremissaCalculadora();

    // this.recalcular();
  }

  async buscarVendPodeAlterarCD() {
    try {
      this.carregandoService.mostra('buscarVendPodeAlterarCD');
      this.vendPodeAlterarCD = await this.funcionarioService.consultaPodeAlterarCD().toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarVendPodeAlterarCD');
    }
  }

  buscarDescricaoCD() {
    if (
      this.cliente &&
      this.cliente.idCD !== null &&
      this.cliente.idCD !== undefined &&
      this.cds &&
      this.cds.some((p) => p.id === this.cliente.idCD)
    ) {
      return this.cds.find((p) => p.id === this.cliente.idCD).descricao;
    } else {
      return '';
    }
  }

  editarFileira(fileira) {
    this.fileira = fileira;
    this.excluirFileira(fileira);
  }

  excluirFileira(fileira) {
    this.fileiras.splice(this.fileiras.indexOf(fileira), 1);
  }

  buscarQtdPainelPorFileira() {
    this.carregandoService.mostra('buscarQtdPainelPorFileira');
    this.premissasService.consultarQtdPainelPorFileira().subscribe(
      (f) => {
        this.qtdMaxPainelPorFileira = f.valor;
        this.carregandoService.esconde('buscarQtdPainelPorFileira');
      },
      (erro) => {
        this.carregandoService.esconde('buscarQtdPainelPorFileira');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarIntPodeAlterarCD() {
    this.carregandoService.mostra('buscarIntPodeAlterarCD');
    this.premissasService.consultarIntPodeAlterarCD().subscribe(
      (f) => {
        this.intPodeAlterarCD = f.valor;

        if (this.intPodeAlterarCD) {
          this.buscarMostrarMsgTrocaCD();
        }
        this.carregandoService.esconde('buscarIntPodeAlterarCD');
      },
      (erro) => {
        this.carregandoService.esconde('buscarIntPodeAlterarCD');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarMostrarMsgTrocaCD() {
    this.carregandoService.mostra('buscarMostrarMsgTrocaCD');
    this.premissasService.consultarMostrarMsgTrocaCD().subscribe(
      (f) => {
        this.mostrarMsgTrocaCD = f;
        this.carregandoService.esconde('buscarMostrarMsgTrocaCD');
      },
      (erro) => {
        this.carregandoService.esconde('buscarMostrarMsgTrocaCD');
        this.notificacaoService.erro(erro);
      }
    );
  }

  novaEstrutura() {
    this.orcamento.painelProduto = this.painelSelecionado;

    let fileira = new Fileira();
    fileira.larguraPainel = this.larguraPainel;
    fileira.comprimentoPainel = this.comprimentoPainel;
    fileira.alturaPainel = this.alturaPainel;

    if (!this.telhadoNaCalculadora) {
      fileira.orientacao = 'retrato';
    }

    if (this.multiFornecedores) {
      fileira.idFornecedorPainel = this.orcamento.painelProduto.idFornecedor;
    }

    if (this.pCentroDistribuicao) {
      fileira.idFornecedorPainel = this.cliente.idCD;
    }

    let totalPaineis = 0;
    // if (this.calculadora) {
    this.fileiras.map((f) => {
      totalPaineis += f.fileiras * f.numPaineis;
    });
    // }

    this.fileira = fileira;

    if (this.fileiraForm) {
      this.fileiraForm.form.markAsPristine();
    }
  }

  // layout

  detalhesDaEstrutura(itens) {
    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(DetalheEstruturaModalComponent, {
      width: largura > 850 ? '800px' : $('body').width().toString() + 'px',
      data: {
        itens: itens
      },
      panelClass: 'modal-card',
      maxHeight: '90vh'
    });
  }

  validarFileira() {
    return (
      (this.telhadoNaCalculadora ||
        (!this.telhadoNaCalculadora &&
          this.fileira.numPaineis !== undefined &&
          this.fileira.numPaineis !== null &&
          this.fileira.numPaineis > 0 &&
          this.fileira.fileiras !== undefined &&
          this.fileira.fileiras !== null &&
          this.fileira.fileiras > 0)) &&
      this.fileira.orientacao !== undefined &&
      this.fileira.telhado !== undefined &&
      this.fileira.fornecedor !== undefined &&
      this.fornecedoresDisponiveis.some((p) => this.fileira.idFornecedorEstrutura === p.idFornecedorEstrutura) &&
      this.cliente !== undefined &&
      (this.fileiras.length === 0 ||
        !this.fileiras.some(
          (p) =>
            p.idDistribuidor !== null &&
            p.idDistribuidor !== undefined &&
            p.idDistribuidor !== this.fileira.idDistribuidor
        ))
    );
  }

  validarFileiraMesmoTipoInversor() {
    return this.fileiras.length === 0 || this.fileiras.some((p) => p.tipoInversor === this.fileira.tipoInversor);
  }

  buscarDesativarPaisagem() {
    this.carregandoService.mostra('buscarDesativarPaisagem');
    this.premissasService.consultarDesativarPaisagem().subscribe(
      (f) => {
        this.orientacaoPaisagem = f.valor;
        if (!this.orientacaoPaisagem && this.fileira) {
          this.fileira.orientacao = 'retrato';
        }
        this.carregandoService.esconde('buscarDesativarPaisagem');
      },
      (erro) => {
        this.carregandoService.esconde('buscarDesativarPaisagem');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarEstruturasPersonalizadas() {
    this.carregandoService.mostra('buscarEstruturasPersonalizadas');
    this.premissasService.consultarEstruturasPersonalizadas().subscribe(
      (f) => {
        this.estruturasPersonalizadas = f;
        if (!this.orientacaoPaisagem && this.fileira) {
          this.fileira.orientacao = 'retrato';
        }
        this.carregandoService.esconde('buscarEstruturasPersonalizadas');
      },
      (erro) => {
        this.carregandoService.esconde('buscarEstruturasPersonalizadas');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarVerPrecosProdutos() {
    this.carregandoService.mostra('buscarVerPrecosProdutos');
    this.premissasService.consultarVerPrecoProdutos().subscribe(
      (f) => {
        this.mostrarValores = f.valor;
        this.carregandoService.esconde('buscarVerPrecosProdutos');
      },
      (erro) => {
        this.carregandoService.esconde('buscarVerPrecosProdutos');
        this.notificacaoService.erro(erro);
      }
    );
  }

  async buscarPremissasSistema() {
    try {
      this.carregandoService.mostra('buscarPremissasSistema');

      this.premissasSistema = await this.premissasService.consultarPremissasSistema().toPromise();

      this.carregandoService.esconde('buscarPremissasSistema');
    } catch (erro) {
      this.carregandoService.esconde('buscarPremissasSistema');
      this.notificacaoService.erro(erro);
    }
  }

  async buscarPremissaCentroDeDistribuicao() {
    try {
      this.carregandoService.mostra('buscarPremissaCentroDeDistribuicao');

      this.pCentroDistribuicao = (await this.premissasService.consultarCentroDeDistribuicao().toPromise()).valor;

      if (this.painelSelecionado && this.pCentroDistribuicao) {
        this.painelSelecionado = undefined;
      }

      if (this.pCentroDistribuicao) {
        this.buscarIntPodeAlterarCD();
        this.buscarCDs();
      }

      this.carregandoService.esconde('buscarPremissaCentroDeDistribuicao');
    } catch (erro) {
      this.carregandoService.esconde('buscarPremissaCentroDeDistribuicao');
      this.notificacaoService.erro(erro);
    }
  }

  buscarObrigaSelecionarTipoInversor() {
    return new Promise((resolve, reject) => {
      this.carregandoService.mostra('buscarObrigaSelecionarTipoInversor');
      this.premissasService.consultarObrigaSelecionarInversorMontarKit().subscribe(
        (f) => {
          this.pObrigaSelecionarTipoInversor = f.valor;

          if (this.pObrigaSelecionarTipoInversor) {
            this.tiposInv = [
              { id: 0, nome: 'String' },
              { id: 1, nome: 'Micro' },
              { id: 2, nome: 'Híbrido' }
            ];
          } else {
            this.tipoInv = -1;
            this.tiposInv = [
              { id: -1, nome: 'Todos' },
              { id: 0, nome: 'String' },
              { id: 1, nome: 'Micro' },
              { id: 2, nome: 'Híbrido' }
            ];
          }

          this.carregandoService.esconde('buscarObrigaSelecionarTipoInversor');
          resolve();
        },
        (erro) => {
          this.carregandoService.esconde('buscarObrigaSelecionarTipoInversor');
          this.notificacaoService.erro(erro);
          reject();
        }
      );
    });
  }

  adicionarEstruturaEProsseguir() {
    if (!this.validarFileiraMesmoTipoInversor()) {
      return;
    }

    if (
      this.telhadoNaCalculadora &&
      ((this.pObrigaSelecionarTipoInversor && this.tipoInv === undefined) ||
        this.potenciaDesejada <= 0 ||
        !this.painelSelecionado ||
        !this.cliente ||
        !this.validarFileira() ||
        !this.possuiIrradiacao ||
        (this.bloquearSistema && !this.administrador))
    ) {
      return;
    }

    if (
      !this.telhadoNaCalculadora &&
      this.fileiras.length === 0 &&
      ((this.pObrigaSelecionarTipoInversor && this.tipoInv === undefined) ||
        !this.validarFileira() ||
        !this.possuiIrradiacao ||
        (this.bloquearSistema && !this.administrador))
    ) {
      return;
    }

    if (this.pCentroDistribuicao && (this.cliente.idCD === null || this.cliente.idCD === undefined)) {
      return;
    }

    this.adicionarEstrutura()
      .then(() => this.prosseguir())
      .catch((err) => {
        this.notificacaoService.erro(err);
      })
      .finally(() => {});
  }

  adicionarEstrutura(prosseguir?: boolean) {
    if (
      (this.pObrigaSelecionarTipoInversor && this.tipoInv === undefined) ||
      !this.possuiIrradiacao ||
      !this.validarFileira() ||
      !this.validarFileiraMesmoTipoInversor()
    ) {
      return;
    }

    return new Promise((resolve, reject) => {
      this.carregandoService.mostra('atualizarFileira');

      this.fileira.qtdTotalModulosTodosLayouts = this.quantidadeDePaineis;

      this.fileira.uf = this.estadoSelecionado;

      this.pedidoService.atualizarFileira(this.fileira).subscribe(
        async (resp) => {
          this.fileira.valorTotal = resp.valorTotal;
          this.fileira.itens = resp.itens;
          this.fileira.telhadoDescricao = resp.telhadoDescricao;
          this.fileira.fornecedorDescricao = resp.fornecedorDescricao;
          // if (recalcular) {
          //   this.buscarItensEstrutura(null, false);
          // }
          // this.verificaPaineisEstrutura();
          this.fileiras.push(this.fileira);

          this.novaEstrutura();

          const pAll = this.fileiras.map((forn: any): Promise<any> => {
            return new Promise((res, rej) => {
              try {
                if (forn.idFornecedorEstrutura !== null && forn.idFornecedorEstrutura !== undefined) {
                  forn.logo$ = this.fornecedorEstruturaService
                    .consultarImagemPorId(forn.idFornecedorEstrutura)
                    .map((m) =>
                      m !== null && m !== undefined ? this.utilitarioService.toBase64ComInicio(m) : Promise.resolve('')
                    )
                    .toPromise();
                  forn.logo$
                    .then((p) => {
                      forn.buscouImagem = true;
                      res();
                    })
                    .catch((err) => {
                      res();
                    });
                } else {
                  res();
                }
              } catch (err) {
                rej(err);
              }
            });
          });

          await Promise.all(pAll);

          this.fornecedoresDisponiveis = [];
          this.montarAgrupamentoEstruturas();
          this.carregandoService.esconde('atualizarFileira');
          resolve();
        },
        (erro) => {
          this.carregandoService.esconde('atualizarFileira');
          this.notificacaoService.erro(erro);
          this.fileiras = [];
          this.novaEstrutura();
          reject();
        }
      );
    });
  }

  nomeArquivoEstrutura(fileira) {
    if (fileira.fornecedor === undefined || fileira.fornecedor === null) {
      return 'semestrutura';
    } else {
      switch (fileira.fornecedor) {
        case 0:
          return 'alfix';
        case 1:
          return 'photoenergy';
        case 2:
          return 'gosolar';
        case 3:
          return 'fotus';
        case 4:
        case 10:
          return 'romagnole';
        case 5:
          return 'brassunny';
        case 6:
          return 'ssm';
        case 7:
          return 'lbsolar';
        case 8:
          return 'viener';
        case 9:
          return 'ccm';
        case 11:
          return 'bellesystem';
        case 12:
          return 'pratyc';
        case 13:
          return 'e3';
        case 14:
          return 'solargroup';
        case 15:
        case 16:
        case 17:
          return 'vertys';
        case 18:
          return 'k2';
      }
    }
  }

  validaNumPaineis() {
    if (
      this.fileira.numPaineis !== null &&
      this.fileira.numPaineis !== undefined &&
      this.qtdMaxPainelPorFileira > 0 &&
      this.fileira.numPaineis > this.qtdMaxPainelPorFileira
    ) {
      swal({
        title: 'Atenção!!',
        text: 'A estrutura selecionada só permite ' + this.qtdMaxPainelPorFileira + ' painéis por fileira!',
        type: 'warning',
        confirmButtonClass: 'btn btn-warning',
        buttonsStyling: false,
        allowEnterKey: false
      }).then((result) => {
        this.fileira.numPaineis = this.qtdMaxPainelPorFileira;
        this.buscarFornecedoresPorTelhado();
      });
    }
  }

  validarIntegradorCentroDistribuicao() {
    if (!this.pCentroDistribuicao || this.integrador) return true;

    if (!this.cliente) {
      swal({
        title: 'Atenção!!',
        text: 'Selecione um integrador para continuar...',
        type: 'warning',
        showCancelButton: true,
        showConfirmButton: false,
        cancelButtonClass: 'btn btn-danger',
        cancelButtonText: 'Fechar',
        buttonsStyling: false
      }).then(() => {
        this.painelSelecionado = undefined;
      });
      return false;
    } else {
      if (!this.cliente.idCD) {
        if (this.premissasSistema.habilitarCDPorCidade) {
          return false;
        } else {
          swal({
            title: 'Atenção!!',
            text: 'Cadastro do integrador incompleto falta (Centro de Distribuição), atualize!',
            type: 'warning',
            showCancelButton: true,
            showConfirmButton: false,
            cancelButtonClass: 'btn btn-danger',
            cancelButtonText: 'Fechar',
            buttonsStyling: false
          });
          return false;
        }
      } else {
        if (this.comEstrutura) {
          if (!this.fileira) {
            this.fileira = new Fileira();
          }

          this.fileira.idFornecedorPainel = this.cliente.idCD;
        }

        return true;
      }
    }
  }

  // calculadora

  calcularSimulacao(irParaKitPersonalizado?) {
    if (this.tensaoSelecionada === undefined || this.tensaoSelecionada === null) {
      this.erroTensaoSelecionada = true;
    }

    if (this.perdas === undefined || this.perdas === null) {
      this.perdas = 0;
    }

    this.irradiacaoService.buscarPorIbge(this.cidadeSelecionado).subscribe(
      (irr) => {
        this.irradiacao = irr;

        if (this.irradiacao && this.irradiacao.idIrrad) {
          this.possuiIrradiacao = true;

          // calcula energia fornecida e aplica perdas
          const energiasMeses: number[] = [];

          const irradiacoes = this.irradiacao.meses;

          irradiacoes.forEach((p) =>
            energiasMeses.push(
              (this.potenciaPainel * this.calculoGeracao.eficienciaDoPainel * p * this.calculoGeracao.numeroDiasMes) /
                1000 -
                ((this.potenciaPainel *
                  this.calculoGeracao.eficienciaDoPainel *
                  p *
                  this.calculoGeracao.numeroDiasMes) /
                  1000) *
                  (this.perdas / 100)
            )
          );
          // this.utilitarioService.retornaMeses(this.irradiacao).forEach(p =>
          //   energiasMeses.push(((this.simulacao.potenciaPainel * 0.8 * p * 30.4) / 1000) -
          //     (((this.simulacao.potenciaPainel * 0.8 * p * 30.4) / 1000) * (this.simulacao.perdas / 100))));

          if (this.percGeracao === null || this.percGeracao === undefined) {
            this.percGeracao = 100;
          }

          if (this.calcularPor === '0') {
            const potenciaComPercentual = Number(((this.potenciaDesejada * Number(this.percGeracao)) / 100).toFixed(2));

            let qtdNecessaria = 0;
            energiasMeses.forEach((p) => (qtdNecessaria += potenciaComPercentual / p));
            qtdNecessaria = qtdNecessaria / 12;
            this.producaoPorPainel = Number((potenciaComPercentual / qtdNecessaria).toFixed(1));
            this.quantidadeDePaineis = Math.ceil(Number(qtdNecessaria.toFixed(1)));

            this.potTotal = Number(((this.potenciaPainel * this.quantidadeDePaineis) / 1000).toFixed(2));
          } else {
            this.potTotal = this.potTotalDesejada;

            this.quantidadeDePaineis = Math.ceil(Number(((this.potTotal * 1000) / this.potenciaPainel).toFixed(1)));
          }

          if (isNaN(this.potTotal)) {
            this.potTotal = null;
          }

          let media = 0;
          let mediaSemPerda = 0;

          this.meses = [];

          for (let i = 0; i < irradiacoes.length; i++) {
            const valorMes =
              ((irradiacoes[i] *
                this.potenciaPainel *
                this.calculoGeracao.eficienciaDoPainel *
                this.calculoGeracao.numeroDiasMes) /
                1000) *
              this.quantidadeDePaineis;

            this.meses[i] =
              ((irradiacoes[i] *
                this.potenciaPainel *
                this.calculoGeracao.eficienciaDoPainel *
                this.calculoGeracao.numeroDiasMes) /
                1000) *
              this.quantidadeDePaineis;

            mediaSemPerda += Number(Number(this.meses[i]).toFixed(0));

            this.meses[i] -= (valorMes * Number(this.perdas)) / 100;
            this.meses[i] = Number(this.meses[i]).toFixed(0).replace('.', ',');
            media += Number(this.meses[i].toString().replace(',', '.'));
          }

          // this.projeto.mediaFornSemPerda = (mediaSemPerda / 12).toFixed(0);

          media = media / 12;
          this.fatorGeracao = media.toFixed(0);
          if (this.calcularPor === '1') {
            this.potenciaDesejada = this.fatorGeracao;
          }
          this.calculou = true;

          this.storage.uf = this.estadoSelecionado;
          this.storage.cidade = this.cidadeSelecionado;
          this.storage.painel = this.painelSelecionado;
          this.storage.fase = this.faseSelecionada;
          this.storage.tensao = this.tensaoSelecionada;
          this.storage.calcularPor = this.calcularPor;
          this.storage.potencia = this.calcularPor === '0' ? this.potenciaDesejada : this.potTotalDesejada;
          this.storage.marca = this.marcaSelecionada === -1 ? null : this.marcaSelecionada;
          this.storage.telhado = this.telhadoSelecionado;
          this.storage.fornecedor = this.fornecedorSelecionado;
          this.storage.usarTransformador = this.usarTransformador;
          // this.storage.incluirStringBox = this.incluirStringBox;

          if (!this.integrador) {
            if (this.cliente) {
              this.storage.idCliente = this.cliente.id;
            }
            if (this.vendedor !== null && this.vendedor !== undefined) {
              this.storage.idVendedor = this.vendedor.idFuncion;
            } else {
              this.storage.idVendedor = this.usuarioLogado.id;
            }
          }

          localStorage.setItem('calculadora', JSON.stringify(this.storage));
          this.voltouPagina = true;

          if (irParaKitPersonalizado) {
            // this.kitPersonalizado();
          }

          if (this.telhadoNaCalculadora) {
            if (!this.fileira) {
              this.novaEstrutura();
            }

            this.fileira.orientacao = 'retrato';
            this.fileira.numPaineis = this.quantidadeDePaineis;
            this.fileira.fileiras = 1;
          }

          this.buscarMarcasInversoresPorCombinacao();
          this.buscarMarcasAgrupamentoStringbox();
        } else {
          this.possuiIrradiacao = false;

          if (this.jaSelecionouCidade) {
            swal({
              title: 'Atenção!!',
              text: 'A localização selecionada não possui irradiação cadastrada!',
              type: 'warning',
              confirmButtonClass: 'btn btn-warning',
              buttonsStyling: false,
              allowEnterKey: false
            });
          }
        }

        this.carregandoService.esconde('buscaIrradiacao');
      },
      (erro) => {
        this.carregandoService.esconde('buscaIrradiacao');
        this.notificacaoService.erro(erro);
      }
    );
  }

  recalcular() {
    // if (this.calculou) {
    this.calcularSimulacao();
    // }
  }

  prosseguir() {
    if (
      this.premissasSistema.usarAgrupamentoStringbox &&
      this.incluirStringBox &&
      (this.marcaStringboxSelecionada === null || this.marcaStringboxSelecionada === undefined)
    ) {
      return;
    }

    if (this.pCentroDistribuicao && (this.cliente.idCD === null || this.cliente.idCD === undefined)) {
      return;
    }

    // console.log('prosseguiu')
    this.kitPersonalizado();
  }

  gerarLogAcesso() {
    const logAcesso: LogAcesso = {
      tipo: TipoDeLogAcesso.MontarKit,
      uf: this.estadoSelecionado,
      ibge: Number(this.cidadeSelecionado),
      idPainel: this.painelSelecionado,
      fase: this.faseSelecionada,
      tensao: this.tensaoSelecionada,
      tipoCalculo: Number(this.calcularPor),
      potencia: Number(this.potTotalDesejada),
      consumo: Number(this.potenciaDesejada),
      idMarcaInversor: this.marcaSelecionada === -1 ? null : this.marcaSelecionada,
      telhado: this.telhadoSelecionado,
      idFornecedor: this.fornecedorSelecionado,
      usarTransformador:
        this.usarTransformadorPremissas && this.faseSelecionada === 2 && this.tensaoSelecionada === 1
          ? this.usarTransformador
          : false,
      incluirStringBox: this.incluirStringBox
    };

    this.carregandoService.mostra('gerarLogAcesso');

    this.logAcessoService.Salvar(logAcesso).subscribe(
      () => {
        this.carregandoService.esconde('gerarLogAcesso');
      },
      (erro) => {
        this.notificacaoService.erro(erro);
        this.carregandoService.esconde('gerarLogAcesso');
      }
    );
  }

  // kitManual() {
  //   this.gerarLogAcesso();

  //   this.carregandoService.mostra('buscaPaineis');

  //   this.produtoService
  //     .consultarPorId(this.painelSelecionado, this.multiFornecedores)
  //     .subscribe(
  //       (pa: Produto) => {
  //         this.router.navigate(['kitpersonalizado'], {
  //           state: {
  //             calculadora: false,
  //             painel: this.painelSelecionado,
  //             tensao: this.tensaoSelecionada,
  //             fase: this.faseSelecionada,
  //             objetoPainel: pa,
  //           },
  //         });
  //         this.carregandoService.esconde('buscaPaineis');
  //       },
  //       (erro) => {
  //         this.carregandoService.esconde('buscaPaineis');
  //       }
  //     );
  // }

  buscarPremissaCalculadora() {
    this.carregandoService.mostra('buscarPremissaCalculadora');

    this.premissasService.consultarTelhadaNaCalculadora().subscribe(
      (result) => {
        this.carregandoService.esconde('buscarPremissaCalculadora');
        if (result.valor) {
          this.telhadoNaCalculadora = true;
        }
      },
      (err) => {
        this.carregandoService.esconde('buscarPremissaCalculadora');
        this.notificacaoService.erro(err);
      }
    );
  }

  kitPersonalizado() {
    this.gerarLogAcesso();

    this.carregandoService.mostra('buscaPaineis');

    let idFornecedorPainel;

    if (this.multiFornecedores) {
      idFornecedorPainel = this.idFornecedor;
    }

    if (this.pCentroDistribuicao) {
      idFornecedorPainel = this.cliente.idCD;
    }

    this.produtoService
      .consultarPorId(
        this.painelSelecionado,
        this.multiFornecedores || this.pCentroDistribuicao,
        this.marcaSelecionada === -1 ? null : this.marcaSelecionada,
        idFornecedorPainel
      )
      .subscribe(
        (pa: Produto) => {
          this.router.navigate(['kitpersonalizado'], {
            state: {
              stateJson: JSON.stringify({
                calculadora: true,
                quantidadeDePaineis: this.quantidadeDePaineis,
                potenciaPainel: this.potenciaPainel,
                potTotal: this.potTotal,
                potenciaDesejada: this.potenciaDesejada,
                fatorGeracao: this.fatorGeracao,
                painel: this.painelSelecionado,
                tensao: this.tensaoSelecionada,
                fase: this.faseSelecionada,
                telhado: this.telhadoSelecionado,
                marca: this.marcaSelecionada === -1 ? null : this.marcaSelecionada,
                fornecedorPadrao: this.fornecedorPadrao,
                larguraPainel: this.larguraPainel,
                comprimentoPainel: this.comprimentoPainel,
                alturaPainel: this.alturaPainel,
                objetoPainel: pa,
                fornecedorSelecionado: this.fornecedorSelecionado,
                uf: this.estadoSelecionado,
                cidade: this.cidadeSelecionado,
                cliente: this.cliente,
                nomeCidade: this.cidade.cidade,
                usarTransformador:
                  this.usarTransformadorPremissas && this.faseSelecionada === 2 && this.tensaoSelecionada === 1
                    ? this.usarTransformador
                    : false,
                incluirStringBox: this.incluirStringBox,
                meses: this.meses,
                fileiras: this.comEstrutura ? this.fileiras : [],
                nome: this.nome,
                comEstrutura: this.comEstrutura,
                vendedor: this.vendedor,
                limDesc: this.limDesc,
                tipoInv: this.tipoInv,
                marcaStringbox:
                  this.incluirStringBox && this.premissasSistema.usarAgrupamentoStringbox
                    ? this.marcaStringboxSelecionada
                    : null
              })
            }
          });
          this.carregandoService.esconde('buscaPaineis');
        },
        (erro) => {
          this.carregandoService.esconde('buscaPaineis');
        }
      );
  }

  selecionarFornecedor(fornecedor) {
    this.fileira.idFornecedorEstrutura = fornecedor.idFornecedorEstrutura;
    this.fileira.idDistribuidor = fornecedor.idDistribuidor;
    this.fileira.fornecedor = fornecedor.fornecedor;
    this.fileira.tipoInversor = fornecedor.tipoInversor;
    this.fileira.microInversor = fornecedor.tipoInversor === 1;

    if (
      this.fileira.numPaineis !== null &&
      this.fileira.numPaineis !== undefined &&
      !this.telhadoNaCalculadora &&
      this.qtdMaxPainelPorFileira > 0 &&
      this.fileira.numPaineis > this.qtdMaxPainelPorFileira
    ) {
      swal({
        title: 'Atenção!!',
        text: 'A estrutura selecionada só permite ' + this.qtdMaxPainelPorFileira + ' painéis por fileira!',
        type: 'warning',
        confirmButtonClass: 'btn btn-warning',
        buttonsStyling: false,
        allowEnterKey: false
      }).then((result) => {
        this.fileira.numPaineis = this.qtdMaxPainelPorFileira;
        this.buscarFornecedoresPorTelhado();
      });
    }
  }

  selecionarOrientacao(orientacao) {
    this.fileira.orientacao = orientacao;
    this.buscarFornecedoresPorTelhado();
  }

  selecionarTelhado(telhado) {
    this.telhadoSelecionado = telhado;
    this.fileira.telhado = telhado;
    // if (telhado === 6) {
    //   this.fileira.orientacao = 'retrato';
    // }
    this.buscarFornecedoresPorTelhado();
  }

  selecionaSeTemEstrutura(comEstrutura) {
    this.comEstrutura = comEstrutura;

    if (this.comEstrutura) {
      if (!this.painelSelecionado) {
        swal({
          title: 'Atenção!!',
          text: 'Selecione um painel para continuar...',
          type: 'warning',
          showCancelButton: true,
          showConfirmButton: false,
          cancelButtonClass: 'btn btn-danger',
          cancelButtonText: 'Fechar',
          buttonsStyling: false
        }).then(() => {
          this.comEstrutura = false;
        });
      } else if (this.tipoInv === undefined && this.pObrigaSelecionarTipoInversor) {
        swal({
          title: 'Atenção!!',
          text: 'Selecione um tipo de inversor para continuar...',
          type: 'warning',
          showCancelButton: true,
          showConfirmButton: false,
          cancelButtonClass: 'btn btn-danger',
          cancelButtonText: 'Fechar',
          buttonsStyling: false
        }).then(() => {
          this.comEstrutura = false;
        });
      } else {
        this.novaEstrutura();
      }
    } else {
      this.fileiras = [];
      this.fornecedoresDisponiveis = [];
      this.montarAgrupamentoEstruturas();
      this.telhadoSelecionado = undefined;
    }

    this.recalcular();
  }

  selecionarIncluirStringBox(valor) {
    this.incluirStringBox = valor;

    this.buscarMarcasAgrupamentoStringbox();
  }

  validarCampos() {
    return (
      this.estadoSelecionado !== undefined &&
      this.ibgeService !== undefined &&
      this.painelSelecionado !== undefined &&
      this.faseSelecionada !== undefined &&
      this.tensaoSelecionada !== undefined &&
      this.calcularPor !== undefined &&
      this.potenciaDesejada !== undefined &&
      this.potenciaDesejada > 0
    );
  }

  alterouCampoCalculadora() {
    if (this.validarCampos()) {
      if (this.comEstrutura) {
        console.info('buscar produtos de acordo com os novos filtros');
      } else if (this.comEstrutura === false) {
      }
    }
  }

  buscarTextoKitFechado() {
    this.carregandoService.mostra('textoKitFechado');

    this.premissasService.textoKitFechado().subscribe(
      (vars) => {
        this.textoKitFechado = vars.texto;
        // this.menuItemsMobile.find(m => m.path === '/kitfechado').title = vars.texto;
        this.carregandoService.esconde('textoKitFechado');
      },
      (erro) => {
        this.carregandoService.esconde('textoKitFechado');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarMostrarBifasico() {
    this.carregandoService.mostra('buscarMostrarBifasico');
    this.premissasService.consultarMostrarBifasico().subscribe(
      (f) => {
        if (f.valor) {
          this.fases[0].nome = 'Monofásico/Bifásico';
          this.fases = [...this.fases];
        }
        this.carregandoService.esconde('buscarMostrarBifasico');
      },
      (erro) => {
        this.carregandoService.esconde('buscarMostrarBifasico');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarMultiFornecedores() {
    this.carregandoService.mostra('buscarMultiFornecedores');
    this.premissasService.consultarMultiFornecedores().subscribe(
      async (f) => {
        this.multiFornecedores = f.valor;
        this.carregandoService.esconde('buscarMultiFornecedores');

        if (localStorage.getItem('calculadora')) {
          this.voltouPagina = true;
          this.storage = JSON.parse(localStorage.getItem('calculadora'));

          if (!this.pCentroDistribuicao || (this.pCentroDistribuicao && !this.premissasSistema.habilitarCDPorCidade)) {
            this.estadoSelecionado = this.storage.uf;
            this.cidadeSelecionado = this.storage.cidade;
          }
          this.buscarCidades();
          this.painelSelecionado = this.storage.painel;

          this.tensaoSelecionada = this.storage.tensao;
          this.faseSelecionada = this.storage.fase;
          this.calcularPor = this.storage.calcularPor;
          this.calcularPor === '0'
            ? (this.potenciaDesejada = Number(this.storage.potencia))
            : (this.potTotalDesejada = Number(this.storage.potencia));
          this.marcaSelecionada =
            this.storage.marca == null || this.storage.marca == undefined ? -1 : this.storage.marca;
          this.usarTransformador = this.storage.usarTransformador;

          if (this.premissasSistema.comSemStringBox) {
            this.incluirStringBox = this.premissasSistema.comSemStringBoxPadrao;
            // this.incluirStringBox = this.storage.incluirStringBox === null || this.storage.incluirStringBox === undefined ?
            //   this.premissasSistema.comSemStringBoxPadrao : this.storage.incluirStringBox;
          } else {
            this.incluirStringBox = true;
          }

          // this.telhadoSelecionado = this.storage.telhado;
          // if(this.telhadoSelecionado) {
          //   this.selecionarTelhado(this.telhadoSelecionado);
          // }

          // this.buscarFornecedoresPorTelhado();

          if (!this.integrador && this.storage.idCliente !== null && this.storage.idCliente !== undefined) {
            await this.buscarClienteVendedorLimDesc();
          }

          this.selecionarPainel();
          // this.selecionarFase();

          // this.selecionarTensao();
        }
      },
      (erro) => {
        this.carregandoService.esconde('buscarMultiFornecedores');
        this.notificacaoService.erro(erro);
      }
    );
  }

  async buscarClienteVendedorLimDesc() {
    try {
      this.carregandoService.mostra('buscarClienteVendedorLimDesc');

      const cliente = await this.clienteService.consultarPorIdClienteSimples(this.storage.idCliente).toPromise();
      const vendedor = await this.funcionarioService
        .consultarFuncionarioPorIdSimples(this.storage.idVendedor)
        .toPromise();
      const limDesc = await this.funcionarioService.consultarLimitDesc(this.storage.idVendedor).toPromise();

      await this.selecionaCliente(cliente, vendedor, limDesc, false);

      this.carregandoService.esconde('buscarClienteVendedorLimDesc');
    } catch (erro) {
      this.carregandoService.esconde('buscarClienteVendedorLimDesc');
      this.notificacaoService.erro(erro);
    }
  }

  selecionarTensao() {
    this.erroTensaoSelecionada = false;
    // this.buscarMarcasInversoresPorCombinacao();
    this.recalcular();
  }

  selecionarFase() {
    this.tensaoSelecionada = undefined;
  }

  selecionarPainel() {
    if (!this.multiFornecedores && this.pCentroDistribuicao && !this.validarIntegradorCentroDistribuicao()) {
      return;
    }

    //this.selecionaSeTemEstrutura(false);
    //

    this.marcasStringbox = [];
    this.marcaStringboxSelecionada = undefined;

    if (this.painelSelecionado !== null && this.painelSelecionado !== undefined) {
      this.buscarMarcasInversoresPorCombinacao();

      this.carregandoService.mostra('BuscandoProduto');

      this.produtoService
        .consultarPorId(
          this.painelSelecionado,
          this.multiFornecedores || this.pCentroDistribuicao,
          undefined,
          this.pCentroDistribuicao && this.cliente && this.cliente.idCD ? this.cliente.idCD : undefined
        )
        .subscribe(
          (pa: Produto) => {
            this.carregandoService.esconde('BuscandoProduto');

            if (pa.potencia > 0) {
              this.potenciaPainel = pa.potencia;
              this.larguraPainel = pa.largura;
              this.comprimentoPainel = pa.comprimento;
              this.alturaPainel = pa.altura;
              this.idFornecedor = pa.idFornecedor;

              this.referenciaPainel = pa.referencia;

              this.idPainel = pa.idProduto;
              this.codErpPainel = pa.codErp;

              this.possuiLargura = this.larguraPainel !== null && this.larguraPainel !== undefined;
              this.possuiComprimento = this.comprimentoPainel !== null && this.comprimentoPainel !== undefined;

              if (!this.fileiras.some((p) => p.idPainel === this.idPainel)) {
                this.fileiras = [];
              }

              this.calcularSimulacao();

              this.buscarMarcasAgrupamentoStringbox();

              // this.buscarFornecedoresPorTelhado();
              if (this.comEstrutura) this.buscarFornecedoresPorTelhado();
            } else {
              swal({
                title: 'Atenção!!',
                text: 'O Painel não possui potência!!!',
                type: 'warning',
                confirmButtonClass: 'btn btn-warning',
                buttonsStyling: false,
                allowEnterKey: false
              }).then((result) => {
                this.potenciaPainel = undefined;
                this.larguraPainel = undefined;
                this.comprimentoPainel = undefined;
                this.alturaPainel = undefined;
                this.idFornecedor = undefined;

                this.referenciaPainel = undefined;

                this.idPainel = undefined;
                this.codErpPainel = undefined;

                this.possuiLargura = false;
                this.possuiComprimento = false;
                this.painelSelecionado = undefined;

                this.fileiras = [];

                this.marcasStringbox = [];
                this.marcaStringboxSelecionada = undefined;
              });
            }

            this.carregandoService.esconde('selecionarPainel');
          },
          (erro) => {
            this.carregandoService.esconde('BuscandoProduto');
            this.carregandoService.esconde('selecionarPainel');
          }
        );
    }
  }

  buscarFornecedoresPorTelhado() {
    if (!this.fileira) {
      this.fileira = new Fileira();
    }

    if (this.fileira.fileiras !== undefined) {
      this.fileira.fileiras = Number(this.fileira.fileiras);
    }

    if (this.fileira.numPaineis !== undefined) {
      this.fileira.numPaineis = Number(this.fileira.numPaineis);
    }

    this.fileira.uf = this.estadoSelecionado;

    if (
      this.telhadoSelecionado !== null &&
      this.telhadoSelecionado !== undefined &&
      this.telhadoSelecionado !== -1 &&
      this.painelSelecionado !== null &&
      this.painelSelecionado !== undefined &&
      this.potenciaDesejada > 0 &&
      ((!this.telhadoNaCalculadora &&
        this.fileira.numPaineis !== undefined &&
        this.fileira.numPaineis !== null &&
        this.fileira.numPaineis > 0 &&
        this.fileira.fileiras !== undefined &&
        this.fileira.fileiras !== null &&
        this.fileira.fileiras > 0) ||
        this.telhadoNaCalculadora) &&
      this.fileira.orientacao !== undefined &&
      this.fileira.orientacao !== null &&
      !(this.pCentroDistribuicao && !this.validarIntegradorCentroDistribuicao())
    ) {
      // this.novaFileira.fileiras = this.fileira.fileiras;
      // this.novaFileira.numPaineis = this.fileira.numPaineis;
      this.fileira.telhado = this.telhadoSelecionado;
      // this.novaFileira.orientacao = 'retrato';
      this.fileira.larguraPainel = this.larguraPainel;
      this.fileira.comprimentoPainel = this.comprimentoPainel;
      this.fileira.alturaPainel = this.alturaPainel;
      this.fileira.referenciaPainel = this.referenciaPainel;

      this.fileira.potenciaTotal = this.potTotal !== null && this.potTotal !== undefined ? Number(this.potTotal) : null;

      if (this.multiFornecedores) {
        this.fileira.idFornecedorPainel = this.idFornecedor;
      }

      if (this.pCentroDistribuicao && this.cliente) {
        this.fileira.idFornecedorPainel = this.cliente.idCD;
      }

      if (this.idPainel) {
        this.fileira.idPainel = this.idPainel;
      }

      if (this.codErpPainel) {
        this.fileira.codErpPainel = this.codErpPainel;
      }

      this.fileira.qtdTotalModulosTodosLayouts = this.quantidadeDePaineis;

      this.fileira.microInversor = this.tipoInv === 1;
      this.fileira.tipoInversor = this.tipoInv;

      this.carregandoService.mostra('buscarFornecedores');
      this.pedidoService.buscarFornecedoresEstrutura(this.fileira).subscribe(
        (forns) => {
          this.fornecedoresDisponiveis = forns;
          // if (
          //   this.storage !== undefined &&
          //   this.storage !== null &&
          //   this.storage.telhado === this.telhadoSelecionado
          // ) {
          //   this.fornecedorSelecionado = Number(this.storage.fornecedor);
          // } else {
          //   this.fornecedorSelecionado = undefined;
          //   this.fileira.fornecedor = undefined;
          //   this.fileira.idFornecedorEstrutura = undefined;
          // }

          if (this.fornecedoresDisponiveis.length === 1) {
            this.fornecedorSelecionado = this.fornecedoresDisponiveis[0].fornecedor;
          }

          this.fornecedoresDisponiveis.forEach((forn: any) => {
            if (forn.idFornecedorEstrutura !== null && forn.idFornecedorEstrutura !== undefined) {
              forn.logo$ = this.fornecedorEstruturaService
                .consultarImagemPorId(forn.idFornecedorEstrutura)
                .map((m) =>
                  m !== null && m !== undefined ? this.utilitarioService.toBase64ComInicio(m) : Promise.resolve('')
                )
                .toPromise();
              forn.logo$.then((p) => {
                forn.buscouImagem = true;
              });
            }
          });

          this.montarAgrupamentoEstruturas();

          this.carregandoService.esconde('buscarFornecedores');
        },
        (erro) => {
          this.carregandoService.esconde('buscarFornecedores');
          this.notificacaoService.erro(erro);
        }
      );

      // this.carregandoService.mostra('buscarFornecedoresPorTelhado');
      // this.pedidoService
      //   .buscarFornecedoresPorTelhado(this.telhadoSelecionado)
      //   .subscribe(
      //     (forns) => {
      //       this.fornecedores = forns;
      //       if (
      //         this.storage !== undefined &&
      //         this.storage !== null &&
      //         this.storage.telhado === this.telhadoSelecionado
      //       ) {
      //         this.fornecedorSelecionado = Number(this.storage.fornecedor);
      //       } else {
      //         this.fornecedorSelecionado = undefined;
      //       }
      //       if (this.fornecedores.length === 1) {
      //         this.fornecedorSelecionado = this.fornecedores[0].fornecedor;
      //       }

      //       this.carregandoService.esconde('buscarFornecedoresPorTelhado');
      //     },
      //     (erro) => {
      //       this.carregandoService.esconde('buscarFornecedoresPorTelhado');
      //       this.notificacaoService.erro(erro);
      //     }
      //   );
    } else {
      this.fornecedores = [];
    }
  }

  limpar() {
    localStorage.removeItem('calculadora');
    window.location.reload();
    // this.ngOnInit();
  }

  buscarUsarTransformador() {
    this.carregandoService.mostra('buscarUsarTransformador');
    this.premissasService.consultarUsarTransformador().subscribe(
      (f) => {
        this.usarTransformadorPremissas = f.valor;
        this.carregandoService.esconde('buscarUsarTransformador');
      },
      (erro) => {
        this.carregandoService.esconde('buscarUsarTransformador');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarUsarTelhadoCeramico() {
    this.carregandoService.mostra('buscarVerPrecosProdutos');
    this.premissasService.consultarUsarTelCeramico().subscribe(
      (f) => {
        this.usarTelCeramico = f.valor;
        this.carregandoService.esconde('buscarVerPrecosProdutos');
      },
      (erro) => {
        this.carregandoService.esconde('buscarVerPrecosProdutos');
        this.notificacaoService.erro(erro);
      }
    );
  }

  // buscarUsarTelhadoCeramico() {

  //   this.carregandoService.mostra('consultarTextoFibrometal');
  //   this.premissasService.consultarTextoFibrometal().subscribe(
  //     (textoFibrometal) => {

  //       this.carregandoService.mostra('buscarVerPrecosProdutos');
  //       this.premissasService.consultarUsarTelCeramico().subscribe(
  //         (f) => {
  //           if (f.valor) {
  //             this.telhados = [
  //               ...[
  //                 { id: -1, nome: 'Sem Estrutura' },
  //                 { id: 0, nome: 'Cerâmico' },
  //                 { id: 1, nome: 'Fibrocimento' },
  //                 { id: 8, nome: textoFibrometal.valor },
  //                 { id: 4, nome: 'Metálico' },
  //                 { id: 7, nome: 'Mini trilho ' },
  //                 { id: 5, nome: 'Laje' },
  //                 { id: 6, nome: 'Solo' },
  //               ],
  //             ];
  //           } else {
  //             this.telhados = [
  //               ...[
  //                 { id: -1, nome: 'Sem Estrutura' },
  //                 { id: 9, nome: 'Colonial' },
  //                 { id: 10, nome: 'Romana/Americana' },
  //                 { id: 1, nome: 'Fibrocimento' },
  //                 { id: 8, nome: textoFibrometal.valor },
  //                 { id: 4, nome: 'Metálico' },
  //                 { id: 7, nome: 'Mini trilho ' },
  //                 { id: 5, nome: 'Laje' },
  //                 { id: 6, nome: 'Solo' },
  //               ],
  //             ];
  //           }
  //           this.carregandoService.esconde('buscarVerPrecosProdutos');
  //         },
  //         (erro) => {
  //           this.carregandoService.esconde('buscarVerPrecosProdutos');
  //           this.notificacaoService.erro(erro);
  //         }
  //       );

  //       this.carregandoService.esconde('consultarTextoFibrometal');
  //     },
  //     (erro) => {
  //       this.carregandoService.esconde('consultarTextoFibrometal');
  //       this.notificacaoService.erro(erro);
  //     }
  //   );

  // }

  verificarPremissas() {
    this.carregandoService.mostra('verificarPremissas');
    this.premissasService.consultarTelhadaNaCalculadora().subscribe(
      async (dados) => {
        this.mostrarTelhado = dados.valor;
        this.premissasService.consultarFornecedorPadrao().subscribe(
          (dados) => {
            this.fornecedorPadrao = dados.valor;
            this.carregandoService.esconde('verificarPremissas');
            this.carregandoService.mostra('buscarCalculoGeracao');
            this.buscarPremissasBloqueioSistema();

            this.pedidoService.calculoGeracao().subscribe(
              async (cg) => {
                this.calculoGeracao = cg;
                this.carregandoService.esconde('buscarCalculoGeracao');

                if (this.integrador) {
                  this.buscarUFCidadeIntegrador();
                }

                await this.buscarPaineis();
                this.buscarMarcasInversoresPorCombinacao();
              },
              (erro) => {
                this.carregandoService.esconde('buscarCalculoGeracao');
              }
            );
          },
          (erro) => {
            this.carregandoService.esconde('verificarPremissas');
            this.notificacaoService.erro(erro);
          }
        );
      },
      (erro) => {
        this.carregandoService.esconde('verificarPremissas');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarPremissasBloqueioSistema() {
    this.carregandoService.mostra('buscarBloqSist');
    this.premissasService.consultarBloqSistManuProd().subscribe(
      (data) => {
        this.bloquearSistema = data;
        this.carregandoService.esconde('buscarBloqSist');
      },
      (erro) => {
        this.carregandoService.esconde('buscarBloqSist');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarMarcasAgrupamentoStringbox() {
    if (
      this.premissasSistema.usarAgrupamentoStringbox &&
      this.incluirStringBox &&
      this.tipoInv !== 1 &&
      this.idPainel !== null &&
      this.idPainel !== undefined &&
      this.quantidadeDePaineis &&
      this.tensaoSelecionada !== undefined &&
      this.tensaoSelecionada !== null &&
      this.painelSelecionado !== undefined &&
      this.painelSelecionado !== null &&
      this.faseSelecionada !== undefined &&
      this.faseSelecionada !== null
    ) {
      let idFornecedor: number = undefined;

      if (this.multiFornecedores) {
        idFornecedor = this.idFornecedor;
      }

      if (this.pCentroDistribuicao && this.cliente) {
        idFornecedor = this.cliente.idCD;
      }

      const filtro = {
        fase: this.faseSelecionada,
        idPainel: this.painelSelecionado,
        qtdPainel: this.quantidadeDePaineis,
        tensao: this.tensaoSelecionada,
        fileiras: this.fileiras,
        idMarca: this.marcaSelecionada === -1 ? null : this.marcaSelecionada,
        idFornecedorPainel: idFornecedor,
        usarTransformador: false,
        buscarMicroinversores: false,
        potenciaTotal: 0,
        tipoInv: this.tipoInv === -1 ? null : this.tipoInv
      };

      this.carregandoService.mostra('buscarMarcasAgrupamentoStringbox');
      this.agrupamentoStringboxService.buscarMarcas(filtro).subscribe(
        (data) => {
          this.marcasStringbox = data; // [{ idMarca: -1, descricao: 'Todos' }, ...data];
          this.marcaStringboxSelecionada = this.marcasStringbox.find(
            (m) => m.idMarca === this.marcaStringboxSelecionada
          )
            ? this.marcaStringboxSelecionada
            : null;

          this.marcasStringbox.forEach((marca) => {
            marca.imagem$ = this.arquivoService
              .baixarArquivo(marca.idMarca, TipoArquivo.Marca)
              .map((m) =>
                m !== null && m !== undefined
                  ? this.utilitarioService.toBase64ComInicio(m)
                  : Promise.resolve('./assets/img/com-stringbox.png')
              )
              .toPromise();
            marca.imagem$
              .then((p) => {
                marca.buscouImagem = true;
              })
              .catch((erro) => {
                marca.buscouImagem = true;
                marca.imagem$ = Promise.resolve('./assets/img/com-stringbox.png');
              });
          });

          this.carregandoService.esconde('buscarMarcasAgrupamentoStringbox');
        },
        (erro) => {
          this.carregandoService.esconde('buscarMarcasAgrupamentoStringbox');
          this.notificacaoService.erro(erro);
        }
      );
    } else {
      this.marcasStringbox = [];
      this.marcaStringboxSelecionada = undefined;
    }
  }

  buscarMarcasInversoresPorCombinacao() {
    if (
      !this.quantidadeDePaineis ||
      this.tensaoSelecionada === undefined ||
      this.painelSelecionado === undefined ||
      this.faseSelecionada === undefined
    )
      return;

    let idFornecedor: number = undefined;

    if (this.multiFornecedores) {
      idFornecedor = this.idFornecedor;
    }

    if (this.pCentroDistribuicao && this.cliente) {
      idFornecedor = this.cliente.idCD;
    }

    const filtro = {
      fase: this.faseSelecionada,
      idPainel: this.painelSelecionado,
      qtdPainel: this.quantidadeDePaineis,
      tensao: this.tensaoSelecionada,
      fileiras: this.fileiras,
      idMarca: undefined,
      idFornecedorPainel: idFornecedor,
      usarTransformador: false,
      buscarMicroinversores: false,
      potenciaTotal: 0,
      tipoInv: this.tipoInv === -1 ? null : this.tipoInv
    };

    this.carregandoService.mostra('buscarMarcasInversoresDisponiveis');
    this.marcaService.buscarMarcasInversoresDisponiveis(filtro).subscribe(
      (resp) => {
        this.marcas = [{ idMarca: -1, descricao: 'Todos' }, ...resp];

        this.marcaSelecionada = this.marcas.find((m) => m.idMarca === this.marcaSelecionada)
          ? this.marcaSelecionada
          : -1;

        if (this.comEstrutura && this.fileira) {
          this.buscarFornecedoresPorTelhado();
        }

        this.carregandoService.esconde('buscarMarcasInversoresDisponiveis');
      },
      (erro) => {
        this.carregandoService.esconde('buscarMarcasInversoresDisponiveis');
        this.notificacaoService.erro(erro);
      }
    );
  }

  alterouCD() {
    this.fileira = new Fileira();
    this.fileiras = [];
    this.fornecedoresDisponiveis = [];
    this.montarAgrupamentoEstruturas();
    this.buscarPaineis(true);
  }

  listarMarcas() {
    this.carregandoService.mostra('buscaMarcas');

    this.marcaService.listarPorFamilia(3).subscribe(
      (marcs) => {
        this.marcas = marcs;
        const marcaTodos = new Marca();
        marcaTodos.descricao = 'Todos';
        marcaTodos.idMarca = -1;
        this.marcas.unshift(marcaTodos);
        this.carregandoService.esconde('buscaMarcas');
      },
      (erro) => {
        this.carregandoService.esconde('buscaMarcas');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarUFCidadeIntegrador() {
    this.carregandoService.mostra('buscarUFCidadeIntegrador');

    this.clienteService.consultarPorIdCliente(this.usuarioLogado.id, true).subscribe(
      async (cliente: Cliente) => {
        this.clienteIntegrador = cliente;
        this.cliente = cliente;

        if (this.premissasSistema.habilitarCDPorCidade) {
          this.cliente.idCD = null;
        }

        if (!this.estadoSelecionado && !this.cidadeSelecionado) {
          if (!this.pCentroDistribuicao || (this.pCentroDistribuicao && !this.premissasSistema.habilitarCDPorCidade)) {
            this.estadoSelecionado = cliente.uf;
            this.cidadeSelecionado = cliente.ibge;
          }
        }

        this.naoLimparCidadeSelecionada = true;
        this.alterouEstado = true;
        this.buscarCidades();

        await this.buscarPaineis();
        this.buscarMarcasInversoresPorCombinacao();
        // this.listarMarcas();

        this.carregandoService.esconde('buscarUFCidadeIntegrador');
      },
      (erro) => {
        this.carregandoService.esconde('buscarUFCidadeIntegrador');
      }
    );
  }

  async buscarPaineis(selecionarPainel?) {
    try {
      this.carregandoService.mostra('buscaPaineis');
      this.paineis = await this.produtoService
        .buscarPaineis(this.pCentroDistribuicao && this.cliente && this.cliente.idCD ? this.cliente.idCD : null)
        .toPromise();
      this.paineis.forEach((p) => {
        if (!this.temPainelNomeGrande && p.descricao.length > 56) this.temPainelNomeGrande = true;
      });

      if (
        this.painelSelecionado !== null &&
        this.painelSelecionado !== undefined &&
        this.paineis !== null &&
        this.paineis !== undefined &&
        !this.paineis.some((p) => p.idProduto === Number(this.painelSelecionado))
      ) {
        this.painelSelecionado = undefined;
      }

      if (selecionarPainel) {
        if (this.painelSelecionado !== null && this.painelSelecionado !== undefined) {
          if (this.paineis.some((p) => p.idProduto === this.painelSelecionado)) {
            this.selecionarPainel();
          } else {
            this.painelSelecionado = null;
          }
        }
      }
    } catch (erro) {
    } finally {
      this.carregandoService.esconde('buscaPaineis');
    }
  }

  pesquisarCliente() {
    const dialogRef = this.dialog.open(ClientesModalComponent, {
      width: $('body').width().toString() + 'px',
      data: {
        gi: 1,
        esconderBotao: true
      },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe(async (result: { cliente: Cliente; vendedor: any; limDesc: any }) => {
      if (result) {
        await this.selecionaCliente(result.cliente, result.vendedor, result.limDesc, true);
      }
    });
  }

  async selecionaCliente(cliente: Cliente, vendedor: any, limDesc: any, veioDoModal: boolean) {
    this.descontoFrete = cliente.descFrete;
    this.cliente = cliente;
    this.clienteIntegrador = cliente;
    this.descontoMaximo = this.usuarioLogado.limDesc;

    if (this.premissasSistema.habilitarCDPorCidade) {
      this.cliente.idCD = null;
    }

    this.vendedor = vendedor;

    if (!this.integrador) {
      if (!this.pCentroDistribuicao || (this.pCentroDistribuicao && !this.premissasSistema.habilitarCDPorCidade)) {
        this.estadoSelecionado = cliente.uf;
        this.cidadeSelecionado = cliente.ibge;
      }
    }

    this.alterouEstado = true;
    this.naoLimparCidadeSelecionada = true;
    this.buscarCidades();
    this.limDesc = limDesc;

    if (this.fileirasDeVolta !== null && this.fileirasDeVolta !== undefined && this.fileirasDeVolta.length > 0) {
      this.fileiras = this.fileirasDeVolta;
      this.fileirasDeVolta = [];
    } else {
      this.fileiras = [];
    }

    if (this.pCentroDistribuicao) {
      this.idFornecedor = this.cliente.idCD;

      await this.buscarPaineis();
      this.buscarMarcasInversoresPorCombinacao();
      // this.listarMarcas();

      if (veioDoModal) {
        this.painelSelecionado = undefined;
        this.marcaSelecionada = -1;
      } else {
        if (this.painelSelecionado) {
          this.selecionarPainel();
        }
      }

      this.novaEstrutura();
      this.fornecedoresDisponiveis = [];
      this.montarAgrupamentoEstruturas();
      this.fileira.fornecedor = undefined;
      this.fileira.idFornecedorEstrutura = undefined;

      this.selecionaSeTemEstrutura(this.comEstruturaDeVolta ? true : false);
      this.comEstruturaDeVolta = false;
    }

    if (this.painelSelecionado && !this.pCentroDistribuicao) {
      this.selecionarPainel();
    }
  }

  private loadCidade(item?) {
    this.cidades$ = concat(
      of(item ? [item] : []), // default items
      this.cidadesInput$.pipe(
        distinctUntilChanged(),
        tap(() => (this.cidadesLoading = true)),
        switchMap((term) =>
          this.ibgeService.consultarPorCidade(term).pipe(
            catchError(() => of(item ? [item] : [])), // empty list on error
            tap(() => (this.cidadesLoading = false))
          )
        )
      )
    );
  }

  async buscarCidadesV2() {
    if (this.cidadeSelecionado !== null && this.cidadeSelecionado !== undefined) {
      this.cidade = await this.ibgeService.buscarCidadePorCodIGBE(this.cidadeSelecionado).toPromise();
      this.loadCidade(this.cidade);
      await this.alterouCidade();
    }
  }

  async alterouCidade() {
    if (this.pCentroDistribuicao && this.premissasSistema.habilitarCDPorCidade && this.cliente) {
      if (this.cidadeSelecionado !== null && this.cidadeSelecionado !== undefined) {
        this.jaSelecionouCidade = true;
        this.cidade = await this.ibgeService.buscarCidadePorCodIGBE(this.cidadeSelecionado).toPromise();
        this.estadoSelecionado = this.cidade.uf;
        if (this.cliente.idCD != this.cidade.cd) {
          this.cliente.idCD = this.cidade.cd;
          this.alterouCD();
        } else {
          this.recalcular();
        }
      } else {
        this.estadoSelecionado = null;
        this.cliente.idCD = null;
        this.loadCidade();
        this.alterouCD();
      }
    } else {
      if (this.cidadeSelecionado !== null && this.cidadeSelecionado !== undefined) {
        this.jaSelecionouCidade = true;
        this.cidade = await this.ibgeService.buscarCidadePorCodIGBE(this.cidadeSelecionado).toPromise();
        this.estadoSelecionado = this.cidade.uf;
      } else {
        this.estadoSelecionado = null;
      }

      this.recalcular();
    }
  }

  buscarCidades(nomeCidade?: string) {
    this.buscarCidadesV2();

    return;

    // this.carregandoService.mostra('buscaCidades');

    // if (!this.naoLimparCidadeSelecionada) {
    //   this.cidadeSelecionado = undefined;
    // } else {
    //   this.naoLimparCidadeSelecionada = false;
    // }

    // this.ibgeService.consultarPorEstado(this.estadoSelecionado).subscribe(
    //   (ibges: Ibge[]) => {
    //     this.cidades = ibges;
    //     if (!this.voltouPagina) {
    //       if (nomeCidade) {
    //         this.cidadeSelecionado = this.cidades.find(
    //           (s) =>
    //             this.utilitarioService.remover_acentos_espaco(
    //               s.cidade.toLowerCase().trim()
    //             ) ===
    //             this.utilitarioService.remover_acentos_espaco(
    //               nomeCidade.toLowerCase().trim()
    //             )
    //         )
    //           ? this.cidades.find(
    //             (s) =>
    //               this.utilitarioService.remover_acentos_espaco(
    //                 s.cidade.toLowerCase().trim()
    //               ) ===
    //               this.utilitarioService.remover_acentos_espaco(
    //                 nomeCidade.toLowerCase().trim()
    //               )
    //           ).cod
    //           : undefined;
    //       } else if (
    //         this.integrador &&
    //         !this.buscouCidadeDoIntegrador &&
    //         !this.voltouPagina
    //       ) {
    //         this.cidadeSelecionado = this.cidades.find(
    //           (c) => c.cod === this.clienteIntegrador.ibge
    //         ).cod;
    //         this.buscouCidadeDoIntegrador = true;
    //       } else {
    //         // this.cidadeSelecionado = this.cidades.find(s => s.cod === this.cidadeSelecionado) ?
    //         //   this.cidades.find(s => s.cod === this.cidadeSelecionado).cod : undefined;
    //       }
    //     } else if (!this.alterouEstado && this.cidadeSelecionado) {
    //       this.cidadeSelecionado = this.cidades.find(
    //         (c) => c.cod === this.storage.cidade
    //       ).cod;
    //     }
    //     this.carregandoService.esconde('buscaCidades');
    //   },
    //   (erro) => {
    //     this.carregandoService.esconde('buscaCidades');
    //   }
    // );
  }

  buscarCDs() {
    this.carregandoService.mostra('buscarCDs');

    this.fornecedorService.consultarFornecedores().subscribe(
      (forn) => {
        this.cds = forn;
        this.carregandoService.esconde('buscarCDs');
      },
      (err) => {
        this.carregandoService.esconde('buscarCDs');
        this.notificacaoService.erro(err);
      }
    );
  }

  buscarDescricaoTelhado(fileira: Fileira) {
    switch (fileira.telhado) {
      case 8:
        return this.estruturasPersonalizadas.textoFibrometal;

      case 12:
        return this.estruturasPersonalizadas.textoEstruturaCalhetao;

      case 13:
        return this.estruturasPersonalizadas.textoEstruturaCarport;

      default:
        return fileira.telhadoDescricao;
    }
  }

  changeTipoInv() {
    this.fileira = new Fileira();
    this.fileiras = [];
    this.fornecedoresDisponiveis = [];
    this.montarAgrupamentoEstruturas();

    this.buscarMarcasAgrupamentoStringbox();

    if (this.pObrigaSelecionarTipoInversor) {
      if (this.comEstrutura) {
        this.novaEstrutura();
      }
    }

    // this.buscarMarcasInversoresPorCombinacao();
    this.selecionaSeTemEstrutura(this.comEstrutura);
  }

  retornaDescricaoTipoInversor(tipoInversor) {
    switch (tipoInversor) {
      case 0:
        return 'String';

      case 1:
        return 'Micro';

      case 2:
        return 'Híbrido';
    }
  }

  montarAgrupamentoEstruturas() {
    if (
      this.fornecedoresDisponiveis === null ||
      this.fornecedoresDisponiveis === undefined ||
      this.fornecedoresDisponiveis.length === 0
    ) {
      this.agrupamentosEstrutura = [];
    } else {
      const tiposDisponiveis = [...new Set(this.fornecedoresDisponiveis.map((p) => p.tipoInversor))];
      this.agrupamentosEstrutura = tiposDisponiveis.map((p) => {
        return {
          descricao: this.retornaDescricaoTipoInversor(p),
          itens: this.fornecedoresDisponiveis.filter((f) => f.tipoInversor === p)
        };
      });
    }
  }
}
